export default __webpack_public_path__ + "static/media/SNA.93443055.svg";